import $ from 'jquery'

$(function () {

    if (typeof gtag === undefined) {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
    }

    //track search form in header
    $('form.header__search').on('submit', function () {
        var s = $(this).find('input[name="s"]').val();
        if (s) {
            gtag('event', 'header_search', {
                query: s,
            });
        }
    });

    //search form on search page
    $('form.search__form').on('submit', function () {
        var s = $(this).find('input[name="s"]').val();
        if (s) {
            gtag('event', 'search_page_search', {
                query: s,
            });
        }
    });

    //track contact button trigger
    $('.contact-button__trigger').on('click', function () {
        gtag('event', 'contact_button_click');
    });

    //track split screen on homepage
    $('.cover-screen__slider').on('click', function () {
        var section = $(this).closest('section');
        var title = section.find('.cover-screen__menu h3').first().text();
        gtag('event', 'cover_screen_open_section', {
            section: title,
        });
    });

    $('.cover-screen__menu a').on('click', function () {
        var section = $(this).closest('section');
        var title = section.find('.cover-screen__menu h3').first().text();
        gtag('event', 'cover_screen_link_click', {
            section: title,
            link: $(this).attr('href'),
            link_title: $(this).text(),
        });
    });

    //track links in main menu
    $('.header__menu .menu a').on('click', function () {
        gtag('event', 'header_menu_link_click', {
            link: $(this).attr('href'),
            link_title: $(this).text(),
        });
    });

});